import { RootState } from "@/app/stores"
import { getProcessingTransactions, IGetProcessingTransactionsResults } from "@/shared/api/bonuses"
import { getCommunityTransactions } from "@/shared/api/community"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchBonusProcessingTransactions = createAsyncThunk<
    IGetProcessingTransactionsResults,
    void,
    { state: RootState }
>('bonusProcessingTransactions/fetchBonusProcessingTransactions', async (_, thunkAPI) => {
    try {
        const { page, limit, startDate, endDate, bonusId, withAccrual } = thunkAPI.getState().bonusProcessingTransactions
        const data = await getProcessingTransactions(page, limit, startDate, endDate, bonusId, undefined, withAccrual === 'all' ? undefined : withAccrual)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
